<template>
  <div class="container">
    <b-row>
      <b-col>
        <Visualizar />
      </b-col>
    </b-row>

    <b-row class="row-button">
      <b-col class="one">
        <Modal
          :title="title"
          :text="textOne"
          :text_Two="text_Two"
          :text_One="text_One"
          :text_three="text_three"
          :text_four="text_four"
          :uno="uno"
          :dos="dos"
          :tres="tres"
          :cuatro="cuatro"
          :cinco="cinco"
          :text_eleven="text_eleven"
        />
      </b-col>
      <b-col class="btn-direction-flex">
        <b-button
          pill
          variant="primary"
          class="btn-one"
          @click="guardarBorrador"
          v-if="userPermission"
          >Guardar como borrador</b-button
        >
        <b-button
          pill
          variant="primary"
          class="btn-two"
          @click="guardarFinalizado"
          v-if="userPermission"
          >Guardar y finalizar</b-button
        >
      </b-col>
    </b-row>

    <b-row>
      <b-col class="title">
        <h5>Presentación del Ministro</h5>
      </b-col>
    </b-row>

    <b-row>
      <CkEditorText :modifyContent="modifyContent" :borrador="borrador" />
    </b-row>
  </div>
</template>

<script>
import Visualizar from "../../../../components/button/escritorio/Visualizar.vue";
import CkEditorText from "../../../../components/private/CkEditorText";
import axios from "axios";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import { showAlert } from "../../../../components/tools/utils";
import Modal from "../../../../components/tools/Modal";
export default {
  components: {
    Visualizar,
    CkEditorText,
    Modal,
  },
  data() {
    return {
      userPermission: true,
      userPermissions: true,
      content: "",
      nombre: "presentacion_ministro",
      borrador: "",
      title: "Presentación del Ministro",
      textOne:
        "Cuenta pública del Ministerio en su conjunto, a través de una breve descripción, su misión, servicios relacionados o dependientes, recursos financieros, dotación, ciudadanos a los que atiende o afecta y principales logros o resultados relevantes de la gestión del año 2020.",
      text_Two:
        "Adicionalmente agregar resultados o logros relevantes de Compromisos del período de Gobierno 2018-2022, que el Ministro del ramo decida resaltar. ",
      text_One:
        "Debe permitir vincular algún resultado del Ministerio con logro(s) relevante(s) de los Servicios, presentando los avances del desempeño institucional, con efecto en los usuarios, beneficiarios o ciudadanos para el caso de instituciones que atienden directa o indirectamente usuarios, beneficiarios o ciudadanos.",
      text_three:
        "En especial, considerar aquellos resultados relacionados con las prioridades del Plan de Gobierno 2018-2022, prioridades ministeriales del período, prioridades manifestadas ciudadanas, Presupuesto, y Productos Estratégicos, según corresponda.",
      text_four:
        "A modo de orientación, se podrían considerar algunas acciones, actividades o proyectos relacionados con:",
      uno:
        "•	Mejores resultados en la provisión de bienes y servicios (productos estratégicos), expresados, por ejemplo, en niveles de cobertura, efecto en los usuarios, beneficiarios, ciudadanos u otras variables relevantes de medición.",
      dos:
        "•	Fortalecimiento de las capacidades con que cuentan las diversas áreas o centros de responsabilidad de la institución mediante la implementación de leyes, programas, iniciativas o planes desarrollados.",
      tres:
        "•	Cumplimiento de compromisos existentes en la agenda de gobierno, ministerio o servicio.",
      cuatro:
        "•	Avances en áreas de gestión transversal, que contribuyan a una mayor eficacia y/o eficiencia en la operación del Servicio.",
      cinco: "•	Otros logros que sean considerados relevantes por el Servicio.",
      text_eleven:
        "Para la presentación de cada avance se deberá acompañar una breve descripción cualitativa que permita contextualizar el avance que se describe y exponerlo de forma precisa y objetiva. También, se recomienda fuertemente que se sustente cuantitativamente, y podrá apoyarse con gráficos y tablas.",
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    modifyContent: function(text) {
      this.content = text;
    },
    buildData: function(type) {
      return {
        nombre: this.nombre,
        elaboracion: type,
        data: {
          content: this.content,
        },
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    guardarBorrador: async function() {
      try {
        const toSend = this.buildData("borrador");

        await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: this.nombre,
            elaboracion: "borrador",
            data: {
              content: this.content,
            },
            anio: process.env.VUE_APP_ANIO,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );
          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
      }
    },
    guardarFinalizado: async function() {
      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar el documento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const toSend = this.buildData("finalizado");

            await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardando documento",
              timerProgressBar: true,
              timer: 3000,
            });
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: this.nombre,
                elaboracion: "finalizado",
                data: {
                  content: this.content,
                },
                anio: process.env.VUE_APP_ANIO,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );
              showAlert({
                icon: "success",
                text: "Documento Guardando ",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },
    obtenerBorrador: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: this.nombre,
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        if (res.data) {
          this.borrador = res.data.info.content;
        }
      } catch (error) {
        console.log(error);
      }
    },
    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        console.log("To send", toSend);
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const relacionUs = this.usuario.servicios.find(
          (s) => s.id === this.$route.params.idServicio
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);
        // Guardar Borrador Encargado BGI
        if (
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 6)
        ) {
          this.userPermissions = false;
        }

        //Guardar y finalizar Encargado BGI
        if (
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 6)
        ) {
          this.userPermission = false;
        }

        //Guardar y finalizar Jefe de Servicio
      } catch (error) {
        console.log(error);
      }
    },
    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (relacionUs.permisos.find((p) => p.permisoId === 5)) {
        this.userPermission = false;
      }
    },
  },
  mounted() {
    this.obtenerBorrador();
    this.obtenerRevision();
    this.obtenerRelacionUsuarioServicio();
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}
.btn-one {
  margin-right: 20px;
}

.btn-direction-flex {
  text-align: end;
}

.title {
  margin-top: 20px;
  margin-bottom: 21px;
  text-align: center;
  color: #052333;
}

.title > h5 {
  font-weight: bold;
}

.row-button {
  margin-bottom: 30px;
}
@media screen and (max-width: 784px) {
  .btn-one {
    font-size: 11px;
    margin-right: 5px;
  }
  .btn-two {
    font-size: 11px;
  }
}

@media screen and (max-width: 569px) {
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}

@media screen and (max-width: 417px) {
  .one {
    display: none;
  }
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
    margin-bottom: 15px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
    position: relative;
    top: -6px;
  }
  .btn-direction-flex {
    text-align: start;
    margin-left: 30px;
  }
}
</style>
